// extracted by mini-css-extract-plugin
export default {"PasswordResetEmail":"yt_a bho_qt bho_a bho_w bho_ea bho_ti","PasswordResetEmail__title":"yt_b bho_vp bho_rg bho_va","PasswordResetEmail__subtitle":"yt_c bho_va"};